import { useEffect, useState } from 'react';
import Header from '../../components/feature/Header';

const NewsPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const categories = [
    { id: 'all', label: 'All News' },
    { id: 'projects', label: 'Project Updates' },
    { id: 'company', label: 'Company News' },
    { id: 'industry', label: 'Industry Insights' },
    { id: 'sustainability', label: 'Sustainability' },
  ];

  const newsArticles = [
    {
      id: 1,
      category: 'projects',
      tag: 'Project Update',
      title: 'Downtown Commercial Complex Reaches Completion',
      excerpt: 'Our flagship commercial project in the city center has successfully reached completion ahead of schedule, showcasing our commitment to timely delivery and quality excellence.',
      date: 'March 15, 2024',
      author: 'Project Team',
      image: 'https://public.readdy.ai/ai/img_res/2e4c9f00884d325b7fb5292d9b3c8682.jpg',
      readTime: '5 min read',
    },
    {
      id: 2,
      category: 'company',
      tag: 'Company News',
      title: 'Raissy Expands Operations with New Regional Office',
      excerpt: 'We are excited to announce the opening of our new regional office, expanding our reach and enhancing our ability to serve clients across the region with greater efficiency.',
      date: 'March 10, 2024',
      author: 'Management',
      image: 'https://readdy.ai/api/search-image?query=modern%20corporate%20office%20building%20exterior%20professional%20business%20headquarters%20glass%20facade%20contemporary%20architecture%20bright%20daylight%20clean%20minimalist%20background&width=800&height=600&seq=raissy-news-office-1002&orientation=landscape',
      readTime: '4 min read',
    },
    {
      id: 3,
      category: 'industry',
      tag: 'Industry Insights',
      title: 'The Future of Sustainable Construction Technology',
      excerpt: 'Exploring emerging technologies and innovative practices that are shaping the future of sustainable construction and environmental responsibility in the building industry.',
      date: 'March 5, 2024',
      author: 'Technical Team',
      image: 'https://readdy.ai/api/search-image?query=sustainable%20green%20building%20construction%20solar%20panels%20eco-friendly%20architecture%20modern%20technology%20environmental%20responsibility%20bright%20daylight%20clean%20minimalist%20background&width=800&height=600&seq=raissy-news-sustainable-1003&orientation=landscape',
      readTime: '6 min read',
    },
    {
      id: 4,
      category: 'projects',
      tag: 'Project Update',
      title: 'Luxury Residential Towers Project Milestone Achieved',
      excerpt: 'The twin luxury residential towers project has reached a significant milestone with the completion of structural work, marking another success in our portfolio of premium developments.',
      date: 'February 28, 2024',
      author: 'Project Team',
      image: 'https://readdy.ai/api/search-image?query=luxury%20residential%20towers%20under%20construction%20high-rise%20building%20development%20cranes%20structural%20work%20professional%20photography%20bright%20daylight%20clean%20minimalist%20background&width=800&height=600&seq=raissy-news-residential-1004&orientation=landscape',
      readTime: '5 min read',
    },
    {
      id: 5,
      category: 'sustainability',
      tag: 'Sustainability',
      title: 'Raissy Commits to Carbon Neutral Operations by 2030',
      excerpt: 'Announcing our ambitious sustainability roadmap with concrete targets to achieve carbon neutrality across all operations, reinforcing our commitment to environmental stewardship.',
      date: 'February 20, 2024',
      author: 'Sustainability Team',
      image: 'https://readdy.ai/api/search-image?query=renewable%20energy%20solar%20panels%20wind%20turbines%20green%20technology%20sustainable%20development%20environmental%20commitment%20bright%20daylight%20clean%20minimalist%20background&width=800&height=600&seq=raissy-news-carbon-1005&orientation=landscape',
      readTime: '7 min read',
    },
    {
      id: 6,
      category: 'company',
      tag: 'Company News',
      title: 'Award Recognition for Excellence in Construction',
      excerpt: 'Raissy has been honored with the prestigious Industry Excellence Award, recognizing our outstanding contributions to construction quality and innovation.',
      date: 'February 15, 2024',
      author: 'Management',
      image: 'https://readdy.ai/api/search-image?query=corporate%20award%20ceremony%20trophy%20recognition%20professional%20business%20event%20formal%20celebration%20bright%20clean%20minimalist%20background&width=800&height=600&seq=raissy-news-award-1006&orientation=landscape',
      readTime: '4 min read',
    },
    {
      id: 7,
      category: 'industry',
      tag: 'Industry Insights',
      title: 'Digital Transformation in Construction Management',
      excerpt: 'How digital tools and technologies are revolutionizing project management, improving efficiency, and enabling better collaboration in modern construction projects.',
      date: 'February 10, 2024',
      author: 'Technical Team',
      image: 'https://readdy.ai/api/search-image?query=digital%20technology%20construction%20management%20tablet%20blueprints%20modern%20tools%20professional%20engineering%20bright%20clean%20minimalist%20background&width=800&height=600&seq=raissy-news-digital-1007&orientation=landscape',
      readTime: '6 min read',
    },
    {
      id: 8,
      category: 'projects',
      tag: 'Project Update',
      title: 'Highway Bridge Infrastructure Project Inaugurated',
      excerpt: 'The newly completed highway bridge project has been officially inaugurated, improving regional connectivity and demonstrating our expertise in large-scale infrastructure development.',
      date: 'February 5, 2024',
      author: 'Project Team',
      image: 'https://readdy.ai/api/search-image?query=modern%20highway%20bridge%20inauguration%20ceremony%20infrastructure%20project%20completion%20professional%20event%20bright%20daylight%20clean%20minimalist%20background&width=800&height=600&seq=raissy-news-bridge-1008&orientation=landscape',
      readTime: '5 min read',
    },
    {
      id: 9,
      category: 'company',
      tag: 'Company News',
      title: 'New Strategic Partnership Announcement',
      excerpt: 'Raissy announces a strategic partnership with leading technology providers to enhance our construction capabilities and deliver even greater value to our clients.',
      date: 'January 30, 2024',
      author: 'Management',
      image: 'https://readdy.ai/api/search-image?query=business%20partnership%20handshake%20professional%20corporate%20meeting%20strategic%20collaboration%20bright%20clean%20minimalist%20background&width=800&height=600&seq=raissy-news-partnership-1009&orientation=landscape',
      readTime: '4 min read',
    },
  ];

  const filteredNews =
    selectedCategory === 'all'
      ? newsArticles
      : newsArticles.filter((article) => article.category === selectedCategory);

  const featuredArticle = newsArticles[0];

  return (
    <div className="min-h-screen">
      <Header />

      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20corporate%20news%20media%20center%20professional%20journalism%20broadcasting%20studio%20bright%20clean%20minimalist%20background&width=1920&height=800&seq=raissy-news-hero-1010&orientation=landscape"
            alt="News & Updates"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        <div className="relative z-10 text-center text-white px-6">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">News & Updates</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            Stay Informed About Our Latest Projects and Industry Insights
          </p>
        </div>
      </section>

      {/* Featured Article */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-8 lg:px-12 max-w-[1140px]">
          <div className="mb-12">
            <span className="text-sm font-semibold text-[#0891b2] uppercase tracking-wider">
              Featured Story
            </span>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src={featuredArticle.image}
                alt={featuredArticle.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute top-6 left-6">
                <span className="bg-[#0891b2] text-white px-4 py-2 rounded-md text-sm font-semibold">
                  {featuredArticle.tag}
                </span>
              </div>
            </div>
            <div>
              <div className="flex items-center text-sm text-[#4a4a4a] mb-4">
                <span>{featuredArticle.date}</span>
                <span className="mx-3">•</span>
                <span>{featuredArticle.readTime}</span>
                <span className="mx-3">•</span>
                <span>{featuredArticle.author}</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#1a1a1a] mb-6">
                {featuredArticle.title}
              </h2>
              <p className="text-lg text-[#4a4a4a] mb-8 leading-relaxed">
                {featuredArticle.excerpt}
              </p>
              <button className="bg-[#0891b2] text-white px-8 py-3 rounded-md text-base font-semibold hover:bg-[#0e7490] transition-colors whitespace-nowrap cursor-pointer">
                Read Full Story
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-12 bg-[#f5f5f5] border-y border-gray-200">
        <div className="container mx-auto px-8 lg:px-12 max-w-[1140px]">
          <div className="flex flex-wrap gap-4 justify-center">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-md text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  selectedCategory === category.id
                    ? 'bg-[#0891b2] text-white'
                    : 'bg-white text-[#4a4a4a] hover:bg-gray-100'
                }`}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* News Grid */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-8 lg:px-12 max-w-[1140px]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredNews.slice(1).map((article) => (
              <div
                key={article.id}
                className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-shadow group cursor-pointer"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-white text-[#1a1a1a] px-3 py-1 rounded-md text-xs font-semibold">
                      {article.tag}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center text-xs text-[#4a4a4a] mb-3">
                    <span>{article.date}</span>
                    <span className="mx-2">•</span>
                    <span>{article.readTime}</span>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a1a1a] mb-3 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-[#4a4a4a] mb-4 leading-relaxed line-clamp-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                    <span className="text-sm text-[#4a4a4a]">{article.author}</span>
                    <button className="text-[#0891b2] font-semibold text-sm hover:text-[#0e7490] transition-colors flex items-center cursor-pointer">
                      Read More
                      <i className="ri-arrow-right-line ml-2"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Subscription */}
      <section className="py-20 bg-[#0891b2]">
        <div className="container mx-auto px-8 lg:px-12 max-w-[1140px] text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Stay Updated
          </h2>
          <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
            Subscribe to our newsletter and get the latest news, project updates, and industry insights delivered to your inbox
          </p>
          <form
            id="newsletter-form"
            data-readdy-form
            className="max-w-xl mx-auto flex flex-col sm:flex-row gap-4"
            onSubmit={async (e) => {
              e.preventDefault();
              const form = e.currentTarget;
              const formData = new FormData(form);
              
              try {
                const response = await fetch('https://readdy.ai/api/form/d5j33peihetfqh7m5ka1', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                  },
                  body: new URLSearchParams(formData as any).toString(),
                });

                if (response.ok) {
                  alert('Thank you for subscribing! You will receive our latest updates.');
                  form.reset();
                } else {
                  alert('Sorry, there was an error. Please try again.');
                }
              } catch (error) {
                alert('Sorry, there was an error. Please try again.');
              }
            }}
          >
            <input
              type="email"
              name="email"
              placeholder="Enter your email address"
              required
              className="flex-1 px-6 py-4 rounded-md text-base focus:ring-2 focus:ring-white focus:outline-none"
            />
            <button
              type="submit"
              className="bg-white text-[#0891b2] px-8 py-4 rounded-md text-base font-semibold hover:bg-[#f5f5f5] transition-colors whitespace-nowrap cursor-pointer"
            >
              Subscribe
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default NewsPage;
